import { render, staticRenderFns } from "./UseDesignPaperList.vue?vue&type=template&id=5eb9d382&scoped=true&"
import script from "./UseDesignPaperList.vue?vue&type=script&lang=js&"
export * from "./UseDesignPaperList.vue?vue&type=script&lang=js&"
import style0 from "./UseDesignPaperList.vue?vue&type=style&index=0&id=5eb9d382&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb9d382",
  null
  
)

export default component.exports